import Button from "../../bulma_components/Button.js";
import BULMA_CSS_CLASSES from "../../bulma_components/bulmaCssClasses.js";
import {extendComponent} from "juis-components/ComponentUtils.js";

export default extendComponent(Button, function () {
    this.isLoading = true;
    this.getNode().setStyle("border", "0");
    this.getNode().setStyle("background-color", "transparent");
}, [BULMA_CSS_CLASSES.IS_LARGE]);
